export default __webpack_public_path__ + "static/media/courses2.e6d94c97.svg";